import React, { useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Form, Formik } from "formik";
import {
  AddPredefinedDataResult,
  AddPredefinedDataVal,
  ConfigDataType,
  PredefinedDataInput,
  PredefinedDataOrderField,
  SettingsTitleProps,
  UpdatePredefinedDataByIdResult,
  UpdatePredefinedDataByIdVar,
} from "./queries/types";
import { Operation } from "../../../../../utils/Enum.types";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import Input from "../../../../../stories/Input/Input";
import { Label } from "../../../../../stories/Label/Label";
import { Button } from "../../../../../stories/Button/Button";
import { PredefineDataInputValidate } from "../../../../../utils/validationSchema";
import {
  EMPTY_STRING,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";
import DownArrow from "../../../../../images/DownArrow.svg";
import Close from "../../../../../images/Close.svg";
import {
  handleFormEvent,
  removeMoreSpace,
} from "../../../../../utils/UtilFunctions";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddPredefinedData,
  UpdatePredefinedDataById,
} from "./queries/mutation";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { PredefinedDataNode } from "./queries/queries";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import LoadingModal from "../../../../pages/LoadingModal";

const { Settings } = require("../../json/title.json");
const { PreDefinedData } = require("../../json/config.json");

const AddPredefinedList = (props: any) => {
  const {
    operationType,
    PredefinedDataByTypes,
    setPredefinedModal,
    predefinedModal,
    setSelectedType,
    predefinedId,
    getPredefinedDataByType,
  } = props;

 
  const { user_details } = useLoggedInUserDetails();
  const [message, setMessage] = useState(emptyMessage);

  const initialValues = {
    type: "",
    id: 0,
    indexno: 0,
    value1: "",
    value2: "",
    value3: "",
    value4: "",
  };

  const [formData, setFormData] = useState<PredefinedDataInput>(initialValues);

  const preDefinedDropdown =
    PredefinedDataByTypes?.data &&
    PredefinedDataByTypes?.data?.GetPredefinedDataTypes.map(
      (option: string) => option
    );

  const [AddPredefinedDataFun, { data }] = useMutation<
    AddPredefinedDataResult,
    AddPredefinedDataVal
  >(AddPredefinedData, {
    onError: (e) => {
      setMessage({
        message: e.message,
        flag: true,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdatePredefined] = useMutation<
    UpdatePredefinedDataByIdResult,
    UpdatePredefinedDataByIdVar
  >(UpdatePredefinedDataById, {
    onError: (e) => {
      setMessage({
        message: e.message,
        flag: true,
        operation: Operation.NONE,
      });
    },
  });

  const [predefinedData, { loading }] = useLazyQuery(PredefinedDataNode);

  const HandleValueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData((prevValues: PredefinedDataInput) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
    }));
  };

  const HandleSubmit = async () => {
    try {
     

      const PredefinedDataInputs = {
        type: removeMoreSpace(formData.type),
        index: formData.indexno,
        value1: removeMoreSpace(formData.value1),
        value2: removeMoreSpace(formData.value2),
        value3: removeMoreSpace(formData.value3),
        value4: removeMoreSpace(formData.value4),
      };
     
        if (operationType === Operation.CREATE) {
          await AddPredefinedDataFun({
            variables: {
              
              user_details,
              input: PredefinedDataInputs,
            },
            refetchQueries: [
              {
                query: getPredefinedDataByType,
                variables: {
                  after: null,
                  type: formData.type,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: PredefinedDataOrderField.CREATED_AT,
                  },
                  
                  name: "",
                },
              },
            ],
          }).then(({ data }) => {
            if (data) {
              setSelectedType(formData.type);
              setMessage({
                message: "Pre-Defined Data Added Successfully",
                flag: true,
                operation: Operation.CREATE,
              });
              setPredefinedModal(!predefinedModal);
            }
          });
        } else {
          UpdatePredefined({
            variables: {
              
              id: predefinedId,
              user_details,
              input: PredefinedDataInputs,
            },
            refetchQueries: [
              {
                query: getPredefinedDataByType,
                variables: {
                  after: null,
                  type: formData.type,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: PredefinedDataOrderField.CREATED_AT,
                  },
                  
                  name: "",
                },
              },
            ],
          }).then(({ data }) => {
            if (data) {
              setSelectedType(formData.type);
              setMessage({
                message: "Pre-Defined Data Update Successfully",
                flag: true,
                operation: Operation.UPDATE,
              });
              setPredefinedModal(!predefinedModal);
            }
          });
        }
      
    } catch (error) {}
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
       
        if (predefinedId && operationType === Operation.UPDATE) {
          await predefinedData({
            variables: {
              ids: [predefinedId],
              
            },
          }).then(({ data }) => {
            if (data) {
              const { type, id, index, value1, value2, value3, value4 } =
                data.nodes[0] || EMPTY_STRING;

              setFormData({
                type,
                id,
                indexno: index,
                value1,
                value2,
                value3,
                value4,
              });
            }
          });
        }
      } catch (error) {}
    };
    fetchData();
  }, [predefinedId, operationType, predefinedData]);
  return (
    <div>
      <Formik
        initialValues={formData}
        validationSchema={PredefineDataInputValidate}
        onSubmit={HandleSubmit}
      >
        {(meta) => {
          return (
            <Form className="company-details__add">
              <div className="company-details__add--title">
                <Title>
                  {Settings.PredefinedList.map(
                    (title: SettingsTitleProps, index: React.Key) => {
                      return (
                        <React.Fragment key={index}>
                          {operationType === Operation.CREATE
                            ? title.Registration
                            : title.Update}
                        </React.Fragment>
                      );
                    }
                  )}
                </Title>
                <img
                  src={Close}
                  alt=""
                  onClick={() => {
                    setPredefinedModal(!predefinedModal);
                  }}
                />
              </div>

              <div className="company-details__block">
                <div className="company-details__block--left">
                  {PreDefinedData.SelectLabel.map(
                    (label: ConfigDataType, index: React.Key) => {
                      return (
                        <div key={index} className="label-grid">
                          <Label>{label.LabelName}</Label>
                          {operationType === Operation.CREATE ? (
                            <div>
                              <FormAutocomplete
                                className={formClasses.inputRoot}
                                options={preDefinedDropdown!}
                                openOnFocus
                                value={formData.type}
                                onChange={(e, newValue) => {
                                  if (newValue) {
                                    setFormData((preValue) => ({
                                      ...preValue,
                                      type: newValue as string,
                                    }));
                                  } else {
                                    setFormData((preValue) => ({
                                      ...preValue,
                                      type: EMPTY_STRING,
                                    }));
                                  }
                                }}
                                popupIcon={<img src={DownArrow} alt="/" />}
                                forcePopupIcon
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    name="type"
                                    required
                                    className={formClasses.formControlRoot}
                                  />
                                )}
                              />
                            </div>
                          ) : (
                            <Input
                              type="text"
                              name="Selected Type"
                              value={formData.type}
                              disabled
                            />
                          )}
                        </div>
                      );
                    }
                  )}
                  {PreDefinedData.Labels.map(
                    (label: ConfigDataType, index: React.Key) => {
                      return (
                        <div key={index} className="label-grid">
                          <Label>{label.LabelName}</Label>
                          <Input
                            name={label.inputName}
                            value={formData[label.inputName]}
                            type={label.dataType}
                            onKeyDown={handleFormEvent}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              HandleValueChange(e);
                              meta.handleChange(e);
                            }}
                          />
                        </div>
                      );
                    }
                  )}
                </div>
              </div>

              <Button mode="save" type="submit" />
              <Button
                mode="cancel"
                type="button"
                onClick={() => {
                  setPredefinedModal(!predefinedModal);
                }}
              />
            </Form>
          );
        }}
      </Formik>
      <LoadingModal flag={loading} />
    </div>
  );
};

export default AddPredefinedList;
